import { render, staticRenderFns } from "./NewICD10.vue?vue&type=template&id=3ff551a5&scoped=true"
import script from "./NewICD10.vue?vue&type=script&lang=js"
export * from "./NewICD10.vue?vue&type=script&lang=js"
import style0 from "./NewICD10.vue?vue&type=style&index=0&id=3ff551a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff551a5",
  null
  
)

export default component.exports